import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { getActiveSpan, getRootSpan, spanToBaggageHeader, spanToTraceHeader } from '@sentry/core';

export const sentryInterceptor = (targets: string[]): HttpInterceptorFn => {
  return (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const match = targets.find(target => {
      return request.url.match(target);
    });
    if (!match) {
      return next(request);
    }
    const activeSpan = getActiveSpan();

    if (!activeSpan) {
      return next(request);
    }

    const rootSpan = getRootSpan(activeSpan);

    let update = request.headers;
    const sentryTraceHeader = spanToTraceHeader(rootSpan);
    if (sentryTraceHeader) {
      update = update.append('sentry-trace', sentryTraceHeader);
    }

    const sentryBaggageHeader = spanToBaggageHeader(rootSpan);
    if (sentryBaggageHeader) {
      update = update.append('baggage', sentryBaggageHeader);
    }
    const nextRequest = request.clone({ headers: update });
    return next(nextRequest);
  };
};
